export const isHexColorValid = (str: string) => {
    // Validate hex values
    let color = str

    if (color.substring(0, 1) === "#") {
        color = color.substring(1)
    }

    switch (color.length) {
        case 3:
            return /^[0-9A-F]{3}$/i.test(color)

        case 6:
            return /^[0-9A-F]{6}$/i.test(color)

        case 8:
            return /^[0-9A-F]{8}$/i.test(color)

        default:
            return false
    }
}

export const getContrastColor = (
    hex: string,
    options?: { threshold?: number; darkColor?: string; lightColor?: string }
): string => {
    const mergedOptions = {
        threshold: 0.8,
        darkColor: "#000000",
        lightColor: "#FFFFFF",
        ...options,
    }

    // Calculate the contrast color (black or white) based on luminance
    const r = parseInt(hex.slice(1, 3), 16)
    const g = parseInt(hex.slice(3, 5), 16)
    const b = parseInt(hex.slice(5, 7), 16)

    const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255

    return luminance > mergedOptions.threshold ? mergedOptions.darkColor : mergedOptions.lightColor
}
